import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-tour"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "c-drawer",
            style: _normalizeStyle({
				...(_ctx.offset.top && { top: _ctx.offset.top }),
				...(_ctx.offset.left && { left: _ctx.offset.left }),
				...(_ctx.offset.bottom && { bottom: _ctx.offset.bottom }),
				...(_ctx.offset.right && { right: _ctx.offset.right }),
			}),
            "data-tour": _ctx.TourSelector.DRAWER
          }, [
            _renderSlot(_ctx.$slots, "body", {}, undefined, true)
          ], 12, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}